/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { computed, ref, set } from 'vue-demi';
import { isEmpty } from 'lodash-es';
import { SUBMIT_DIALOG_STATUS, SUBMIT_ERROR_STATUS } from './const';
import { IFormatSubmitResult, ICreationSubmitResult, ISubmitErrorInfo, IFixResultFor1nn } from './types';
import { handleAsyncSubmit, SUBMIT_STATUS } from './utils/submit';
import { trackEventAsyncSubmit } from './utils/submit-track';
import { getFormatSubmitResult, generatorErrorTableData } from './utils/parse-submit-error';
import { getRetrySubmitData } from './utils/generator-retry-data';

/** 弹窗的状态 */
const status = ref<number>(SUBMIT_DIALOG_STATUS.NOT_SUBMIT);
/** 提交进度条 */
const progress = ref<number>(0);
/** 异步提交数据 */
const submitCreationData = ref<Record<string, unknown>>({});
/** 原始提交结果  */
const originSubmitResult = ref<Record<string, unknown>>({});
/** 解析后的提交结果 */
const formatSubmitResult = ref<Partial<IFormatSubmitResult>>({});
/** 报错表格数据 */
const submitErrorInfo = ref<Partial<ISubmitErrorInfo>>({});

export const useCreationAsyncSubmit = (emit?: any) => {
  const visible = computed(() => status.value !== SUBMIT_DIALOG_STATUS.NOT_SUBMIT);
  const isSubmitting = computed(() => status.value === SUBMIT_DIALOG_STATUS.SUBMITTING);
  const isSuccess = computed(() => status.value === SUBMIT_DIALOG_STATUS.SUCCESS);
  const isSubmitFail = computed(() => status.value === SUBMIT_DIALOG_STATUS.FAIL);

  const setSubmitCreationData = data => {
    submitCreationData.value = data;
  };

  const setStatus = newStatus => {
    status.value = newStatus;
  };

  const setProgress = val => {
    progress.value = val;
  };

  const setSubmitResult = (result, isSnapData = false) => {
    originSubmitResult.value = result;
    formatSubmitResult.value = getFormatSubmitResult(result);
    submitErrorInfo.value = generatorErrorTableData(result, isSnapData);
  };

  /**
   * 每次重新提交，则重置之前存储的数据
   **/
  const resetSubmitInfo = () => {
    setStatus(SUBMIT_DIALOG_STATUS.NOT_SUBMIT);
    setProgress(0);
    setSubmitResult({});
    setSubmitCreationData({});
  };

  /**
   * 更新指定表格下标的报错数据
   */
  const updateErrorItemByRowIndex = (rowIndex: number, data) => {
    const tableErrorList = submitErrorInfo.value.data || [];
    const currentErrorItem = tableErrorList[rowIndex];
    if (!currentErrorItem) {
      return;
    }
    set(submitErrorInfo.value, `data.[${rowIndex}]`, { ...currentErrorItem, ...data });
  };

  /**
   * 开始进行异步创建
   * @param data 提交数据
   * @param isSnapData 是否为快照 ID 数据
   */
  const onStartAsyncSubmit = async (data, isSnapData = false): Promise<ICreationSubmitResult> => {
    resetSubmitInfo();

    const submitData = data;
    setSubmitCreationData(submitData);
    setStatus(SUBMIT_DIALOG_STATUS.SUBMITTING);
    // 同步更新进度
    const result = await handleAsyncSubmit(submitData, {
      isSnapData,
      onProgress: val => {
        setProgress(val);
      },
    });

    // 让进度跳到 100%
    const sleepFn = (sleepTime = 1000) => new Promise(resolve => setTimeout(() => resolve(''), sleepTime));
    await sleepFn(500);

    setSubmitResult(result.originResult, isSnapData);

    if (result.status === SUBMIT_STATUS.API_FAIL) {
      setStatus(SUBMIT_DIALOG_STATUS.NOT_SUBMIT);
      result.isSuccess = false;
      result.isExistSuccess = false;
    } else if (formatSubmitResult.value.isExistFail) {
      result.isExistSuccess = true;
      setStatus(SUBMIT_DIALOG_STATUS.FAIL);
      result.isSuccess = false;
      const { isCampaignFail, isAdgroupFail, isCreativeFail } = formatSubmitResult.value || {};
      trackEventAsyncSubmit({
        type: 'async_submit_fail',
        campaign_fail: String(isCampaignFail),
        adgroup_fail: String(isAdgroupFail),
        ad_fail: String(isCreativeFail),
      });
    } else {
      result.isExistSuccess = true;
      setStatus(SUBMIT_DIALOG_STATUS.SUCCESS);
      result.isSuccess = true;
      trackEventAsyncSubmit({
        type: 'async_submit_success',
        is_success: String(true),
      });

      console.log('onStartAsyncSubmit', result);
    }

    // 弹窗内部重试成功，需要把结果同步到创编流，解决部分创意成功需要展示禁用状态
    emit?.('onRetrySuccess', result);

    return result as any;
  };

  /**
   * 在报错表格中进行重试，表格中展示 Loading 和 Success 状态
   */
  const handleOnlyRetryOneAdgroup = async (rowIndex, submitData) => {
    try {
      updateErrorItemByRowIndex(rowIndex, { status: SUBMIT_ERROR_STATUS.RETRYING });

      // eslint-disable-next-line @typescript-eslint/no-empty-function, @ies/prettier/prettier
      const result = await handleAsyncSubmit(submitData, { onProgress: () => { } });
      // 弹窗内部重试成功，需要把结果同步到创编流，解决部分创意成功需要展示禁用状态
      emit?.('onRetrySuccess', result);

      if (result.status === SUBMIT_STATUS.SUCCESS) {
        updateErrorItemByRowIndex(rowIndex, { status: SUBMIT_ERROR_STATUS.SUCCESS });
      } else {
        updateErrorItemByRowIndex(rowIndex, { status: SUBMIT_ERROR_STATUS.FAIL });
      }
    } catch (error) {
      updateErrorItemByRowIndex(rowIndex, { status: SUBMIT_ERROR_STATUS.FAIL });
    }
  };

  /**
   * 关闭提交报错弹窗
   */
  const handleClose = () => {
    setStatus(SUBMIT_DIALOG_STATUS.NOT_SUBMIT);
  };

  /**
   * 报错重试
   * 1. 如果有指定下标，则只重试部分数据
   * 2. 如果没有指定下标，则默认重试所有（会移除成功部分的数据）
   */
  const handleRetry = (rowData, rowIndex) => {
    if (isEmpty(submitCreationData.value)) {
      return;
    }

    const adgroupIndex = rowData?.adgroupIndex;
    const adgroupSubmitData = getRetrySubmitData({
      adgroupIndex,
      submitResult: originSubmitResult.value,
      submitCreationData: submitCreationData.value,
    });

    // 如果指定 adgroup 报错，则只重试指定一个
    if (adgroupIndex !== undefined && rowIndex !== undefined) {
      handleOnlyRetryOneAdgroup(rowIndex, adgroupSubmitData);
    } else {
      onStartAsyncSubmit(adgroupSubmitData);
    }
  };

  const handleFix = data => {
    handleClose();

    if (isEmpty(data)) {
      emit?.('onFix', submitErrorInfo.value.firstErrorInfo);
    } else {
      emit?.('onFix', data);
    }
  };

  const handleFixFor1nn = originData => {
    handleClose();
    const firstErrorInfo: Partial<IFixResultFor1nn> = {};

    if (isEmpty(originData)) {
      const { level, data } = submitErrorInfo.value || {};
      if (level === 'campaign_fail') {
        const { campaign_snap_id: campaignSnapId } = submitCreationData.value || {};
        firstErrorInfo.isCampaignFail = true;
        firstErrorInfo.campaignSnapId = campaignSnapId as string;
      } else if (level === 'adgroup_fail') {
        firstErrorInfo.isAdgroupFail = true;
        firstErrorInfo.adgroupSnapId = data?.[0]?.adgroupSnapId as string;
      } else if (level === 'ad_fail') {
        firstErrorInfo.isCreativeFail = true;
        firstErrorInfo.creativeSnapId = data?.[0]?.creativeSnapId as string;
      }

      emit?.('onFix', firstErrorInfo);
    } else {
      // 目前只有创意支持单条fix,因此这里都是creative数据
      firstErrorInfo.isCreativeFail = true;
      firstErrorInfo.creativeSnapId = originData?.creativeSnapId;
      emit?.('onFix', firstErrorInfo);
    }
  };

  return {
    visible,
    isSubmitting,
    isSuccess,
    isSubmitFail,

    status,
    progress,
    originSubmitResult,
    submitErrorInfo,

    handleClose,
    onStartAsyncSubmit,
    handleRetry,
    handleFix,
    handleFixFor1nn,
  };
};
